import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-occations',
  templateUrl: './occations.component.html',
  styleUrls: ['./occations.component.scss'],
  providers:[ScheduleService,MasterService]
})
export class OccationsComponent implements OnInit {


    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    arrsch:any=[];
    masocc=[];
    objfilt:any={};
      objsch:any={};
      arrasch:any=[];
  
    constructor(private http: HttpClient, private sservice: ScheduleService,private modalService: NgbModal) { }
  
    open(content) {
      this.modalOptions = {
       
        size:'sm'
       
      }
      this.modalService.open(content, this.modalOptions ).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
   
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
    ngOnInit(): void {
  
      this.Bindtable();
     // this.Getsel_sp_masoccation();
    }
  
  

    Bindtable() {
        debugger
        
        
        this.sservice.sel_sp_masoccation()
        .subscribe(
        resultArray =>{
        console.log('result',resultArray) ;
                this.arrsch = resultArray;
                //alert (resultArray.message);
  
            }, error =>
                alert('error in connection')
            );
        
    }
   
  
    opensubject(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objsch={};
       
        
        //console.log('date',this.sservice.getdatetoday().toString())
        this.objsch.occid=0;
        this.objsch.occcode='';
        this.objsch.occname='';
        this.objsch.occtag='';
        this.objsch.hid=0;
        //this.objsch.subgpId=0;
        //this.objsch.holdt1=this.sservice.getdatetoday();
        
        //this.objsubject.subcaId=0;
        // this.objsubcat.subcacd='';
        //this.objsubcat.subcanm='';
        this.objsch.oprtag='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objsch=objdata;
        this.objsch.oprtag='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
       
        
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
  
  
    SaveDetails() {
     
      
     
      console.log('save-model', this.objsch);
      this.sservice.save_sp_masoccation(this.objsch)
          .subscribe(resultArray => {
              console.log('ret-save', resultArray);
              
              alert (resultArray.message);
              if(resultArray.status=='success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
               // this.Getsel_sp_massubgp();
               this.Bindtable();
              }
              
    
          }, error =>
              alert('error in connection')
          );
     // this.closeAddExpenseModal.nativeElement.click();
    }
  
    Deletedetails(objsch) {
  
      if(confirm("Are you sure? you wan't to delete. "))
      {
      var occid = objsch.occid;
      
     // let holdt=this.SchService.converttodate(hodt);
     // var oprtag = "insert"
      var clssubdata = { occid:  objsch.occid, occcode: '', oprtag:'delete',occname:'',occtag:'' };
     // var oprtag = "insert"
      //var clssubdata = { clid: clid, subid: subid, oprtag: this.objsch.oprtype,assid:assid,asstypeid:asstypeid,portion:portion,remarks:remarks,assdt:assdt,clcd:clcd,aycd:aycd };
      
      
     
      console.log('save-model', clssubdata);
      this.sservice.save_sp_masoccation(clssubdata)
          .subscribe(resultArray => {
              console.log('ret-save', resultArray);
              
              alert (resultArray.message);
              if(resultArray.status=='success')
              {
                
               this.Bindtable();
              }
              
    
          }, error =>
              alert('error in connection')
          );
     // this.closeAddExpenseModal.nativeElement.click();
    }
  }
  }